import React from 'react';

interface Props {
  show: boolean;
  text?: string;
  subText?: string;
  progressPct?: number; // 0..100
}

const PlayerLoadingOverlay: React.FC<Props> = ({ show, text = 'Loading…', subText, progressPct }) => {
  if (!show) return null;
  return (
    // Absolute overlay inside the Player container; does not affect header/tabs
    <div className="pointer-events-none absolute inset-0 z-20 rounded-xl flex items-center justify-center bg-neutral-900/40 backdrop-blur-sm supports-[backdrop-filter]:bg-neutral-900/30">
      <div className="pointer-events-auto px-4 py-3 rounded-md border border-neutral-700/50 bg-black/60 text-neutral-200 text-sm shadow-lg w-[min(88vw,28rem)]">
        <div className="flex items-center justify-between gap-3">
          <span className="truncate">{text}</span>
          {typeof progressPct === 'number' && (
            <span className="text-[10px] text-neutral-400 shrink-0">{Math.max(0, Math.min(100, Math.round(progressPct)))}%</span>
          )}
        </div>
        {subText && <div className="mt-1 text-[10px] text-neutral-400 truncate">{subText}</div>}
        {typeof progressPct === 'number' && (
          <div className="mt-2 h-1 rounded bg-neutral-700/50 overflow-hidden">
            <div
              className="h-full bg-emerald-400 rounded"
              style={{ width: `${Math.max(0, Math.min(100, progressPct))}%` }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PlayerLoadingOverlay;
